import gregorian from 'react-date-object/calendars/gregorian';
import persian from 'react-date-object/calendars/persian';
import { DateObject } from 'react-multi-date-picker';

export function convertPersianToGregorian(persianDateString: string) {
  if (!persianDateString) return null as unknown as string;

  try {
    const normalized = persianDateString
      .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
      .replace(/-/g, '/');

    const persianDate = new DateObject({
      date: normalized,
      format: 'YYYY/MM/DD',
      calendar: persian,
    });

    const gregorianDate = persianDate.convert(gregorian);
    const year = gregorianDate.year;
    const month = gregorianDate.month.toString().padStart(2, '0');
    const day = gregorianDate.day.toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('convertPersianToGregorian error:', error);
    return null as unknown as string;
  }
}
